import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const ListSlice =  createSlice({
    name:"ListPermission",
    initialState:{
        Permissions:[""],
    },
    reducers:{
        SetListPerm(state, action: PayloadAction<Array<string>>){
            state.Permissions = action.payload;

        }
    }
});

export const { SetListPerm } =ListSlice.actions
export default ListSlice.reducer